
{
  "familyId": "GET-PROC-SAMENGESTELD",
  "questions": [
    {
      "id": "GET-PROC-SAMENGESTELD-001",
      "familyId": "GET-PROC-SAMENGESTELD",
      "module": "Getalbegrip",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "procenten",
      "subSkill": "proc_samengesteld",
      "questionType": "multiple_choice",
      "question": "Een trui kost €80. Er is 25% korting. Hoeveel betaal je?",
      "context": null,
      "options": ["€60", "€20", "€100", "€75"],
      "correctAnswer": 0,
      "conceptId": "percent_discount_price",
      "variantIndex": 1,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.72,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Korting berekenen in 2 stappen",
            "content": "Stap 1: Bereken de korting. 25% van €80 = 0,25 × €80 = €20. Stap 2: Trek de korting af. €80 − €20 = €60. Je betaalt €60.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Stap 1: Bereken de korting. 25% van €80 = $\\frac{25}{100}$ × €80 = 0,25 × €80 = €20. Stap 2: Trek de korting af van de oorspronkelijke prijs. €80 − €20 = €60. Je betaalt dus €60.",
        "solutionSteps": [
          "Korting: 25% van €80 = €20",
          "Nieuwe prijs: €80 − €20 = €60"
        ],
        "distractorExplanations": {
          "0": "Goed! 25% van €80 = €20 korting. €80 − €20 = €60.",
          "1": "€20 is de korting, niet de prijs die je betaalt. Je moet de korting nog aftrekken van €80: €80 − €20 = €60.",
          "2": "€100 klopt niet. Je hebt de korting opgeteld in plaats van afgetrokken. Bij korting betaal je minder, dus je trekt af: €80 − €20 = €60.",
          "3": "€75 klopt niet. Je hebt waarschijnlijk 25% van €100 berekend (= €25) en dat afgetrokken van €100. Maar de trui kost €80, niet €100. Bereken 25% van €80 = €20, dan €80 − €20 = €60."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.percent-amount-as-final", "label": "Kortingsbedrag €20 als eindprijs gegeven", "optionIndex": 1 },
          { "id": "get.percentage-of-vs-increase", "label": "Korting opgeteld i.p.v. afgetrokken", "optionIndex": 2 },
          { "id": "get.percentage-of-wrong-base", "label": "Percentage berekend van verkeerd basisbedrag (€100 i.p.v. €80)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "GET-PROC-SAMENGESTELD-002",
      "familyId": "GET-PROC-SAMENGESTELD",
      "module": "Getalbegrip",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "procenten",
      "subSkill": "proc_samengesteld",
      "questionType": "multiple_choice",
      "question": "Een fiets kost €240. De prijs stijgt met 10%. Wat is de nieuwe prijs?",
      "context": null,
      "options": ["€264", "€24", "€216", "€260"],
      "correctAnswer": 0,
      "conceptId": "percent_price_increase",
      "variantIndex": 2,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Prijsstijging berekenen in 2 stappen",
            "content": "Stap 1: Bereken de stijging. 10% van €240 = 0,10 × €240 = €24. Stap 2: Tel de stijging op. €240 + €24 = €264. Bij stijging betaal je méér, dus je telt op.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Stap 1: Bereken de stijging. 10% van €240 = 0,10 × €240 = €24. Stap 2: Tel de stijging op bij de oorspronkelijke prijs. €240 + €24 = €264. De nieuwe prijs is €264.",
        "solutionSteps": [
          "Stijging: 10% van €240 = €24",
          "Nieuwe prijs: €240 + €24 = €264"
        ],
        "distractorExplanations": {
          "0": "Goed! 10% van €240 = €24. €240 + €24 = €264.",
          "1": "€24 is het bedrag van de stijging, niet de nieuwe prijs. Je moet de stijging nog optellen bij €240: €240 + €24 = €264.",
          "2": "€216 klopt niet. Je hebt de stijging afgetrokken in plaats van opgeteld. Bij een prijsstijging wordt de prijs hoger: €240 + €24 = €264.",
          "3": "€260 klopt niet. Je hebt waarschijnlijk €20 opgeteld (10% van €200) in plaats van €24 (10% van €240). Bereken altijd het percentage van het juiste bedrag."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.percent-amount-as-final", "label": "Stijgingsbedrag €24 als eindprijs gegeven", "optionIndex": 1 },
          { "id": "get.percentage-of-vs-increase", "label": "Stijging afgetrokken i.p.v. opgeteld", "optionIndex": 2 },
          { "id": "get.percentage-of-wrong-base", "label": "Percentage berekend van afgerond basisbedrag (€200 i.p.v. €240)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "GET-PROC-SAMENGESTELD-003",
      "familyId": "GET-PROC-SAMENGESTELD",
      "module": "Getalbegrip",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "procenten",
      "subSkill": "proc_samengesteld",
      "questionType": "multiple_choice",
      "question": "Een jas kost €150. Er is 20% korting. Daarna is er nog 10% extra korting op de nieuwe prijs. Hoeveel betaal je?",
      "context": null,
      "options": ["€108", "€105", "€120", "€100"],
      "correctAnswer": 0,
      "conceptId": "percent_double_discount",
      "variantIndex": 3,
      "citoDifficulty": 0.62,
      "citoDiscrimination": 0.78,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Dubbele korting: altijd stap voor stap",
            "content": "Stap 1: Eerste korting op de beginprijs. 20% van €150 = €30 → €150 − €30 = €120. Stap 2: Tweede korting op de NIEUWE prijs (€120, niet €150!). 10% van €120 = €12 → €120 − €12 = €108. Let op: je mag de kortingen NIET bij elkaar optellen (20% + 10% ≠ 30% van €150).",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Stap 1: Bereken de eerste korting. 20% van €150 = €30. Nieuwe prijs: €150 − €30 = €120. Stap 2: Bereken de tweede korting op de nieuwe prijs. 10% van €120 = €12. Eindprijs: €120 − €12 = €108. Let op: je berekent de tweede korting op €120, niet op €150!",
        "solutionSteps": [
          "Eerste korting: 20% van €150 = €30 → €120",
          "Tweede korting op nieuwe prijs: 10% van €120 = €12 → €108"
        ],
        "distractorExplanations": {
          "0": "Goed! Eerste korting: 20% van €150 = €30 → €120. Tweede korting: 10% van €120 = €12 → €108.",
          "1": "€105 klopt niet. Je hebt de kortingen bij elkaar opgeteld (20% + 10% = 30%) en dat in één stap berekend: 30% van €150 = €45, €150 − €45 = €105. Maar dat is fout! De tweede korting geldt op de al verlaagde prijs (€120), niet op de oorspronkelijke prijs (€150). Bereken stap voor stap.",
          "2": "€120 klopt niet. Je hebt alleen de eerste korting berekend (20% van €150 = €30, €150 − €30 = €120) maar de tweede korting van 10% vergeten.",
          "3": "€100 klopt niet. Je hebt waarschijnlijk 33% korting berekend of een andere fout gemaakt. Bereken stap voor stap: eerst 20% van €150 = €30 → €120, dan 10% van €120 = €12 → €108."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.percent-compound-added", "label": "20% + 10% = 30% opgeteld i.p.v. stap voor stap", "optionIndex": 1 },
          { "id": "get.percent-step-omitted", "label": "Tweede korting overgeslagen", "optionIndex": 2 },
          { "id": "get.percentage-of-wrong-base", "label": "Fout percentage of verkeerd basisbedrag gebruikt", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "GET-PROC-SAMENGESTELD-004",
      "familyId": "GET-PROC-SAMENGESTELD",
      "module": "Getalbegrip",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "procenten",
      "subSkill": "proc_samengesteld",
      "questionType": "multiple_choice",
      "question": "Een prijs van €100 stijgt met 20%. Daarna daalt de nieuwe prijs met 20%. Wat is de eindprijs?",
      "context": null,
      "options": ["€96", "€100", "€104", "€80"],
      "correctAnswer": 0,
      "conceptId": "percent_increase_decrease_trap",
      "variantIndex": 4,
      "citoDifficulty": 0.72,
      "citoDiscrimination": 0.82,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "+20% en daarna −20% is NIET gelijk aan de beginprijs",
            "content": "Stap 1: +20% van €100 = €20 → nieuwe prijs €120. Stap 2: −20% van €120 (niet €100!) = €24 → eindprijs €120 − €24 = €96. De daling is groter dan de stijging, want 20% van €120 > 20% van €100.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Stap 1: Prijs stijgt met 20%. 20% van €100 = €20. Nieuwe prijs: €100 + €20 = €120. Stap 2: Prijs daalt met 20% van de nieuwe prijs. 20% van €120 = €24. Eindprijs: €120 − €24 = €96. De eindprijs is €96, dus €4 lager dan de beginprijs! Dit is een klassieke val: +20% en daarna −20% is NIET gelijk aan de beginprijs, omdat de daling berekend wordt over het hogere bedrag.",
        "solutionSteps": [
          "Stijging: +20% van €100 = €20 → €120",
          "Daling: −20% van €120 = €24 → €96",
          "Let op: −20% van €120 ≠ −20% van €100!"
        ],
        "distractorExplanations": {
          "0": "Goed! +20% van €100 = €120, dan −20% van €120 = €24, eindprijs €120 − €24 = €96.",
          "1": "€100 is de beginprijs, niet de eindprijs. Dit is de meest gemaakte fout: veel mensen denken dat +20% en daarna −20% uitkomt op de beginprijs. Maar de daling van 20% wordt berekend over €120 (niet over €100), dus je verliest €24, niet €20. Eindprijs = €96.",
          "2": "€104 klopt niet. Er is geen situatie waarbij je uitkomt op €104 bij deze berekening. Controleer je stappen: +20% van €100 = €120, dan −20% van €120 = €24, eindprijs = €96.",
          "3": "€80 klopt niet. Je hebt waarschijnlijk 20% van €100 = €20 afgetrokken van €100 (= €80), maar je bent de eerste stap (de stijging) vergeten. Bereken eerst de stijging: €100 + €20 = €120, dan de daling: €120 − €24 = €96."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.percent-increase-decrease-symmetric", "label": "+20% en −20% beschouwd als gelijk aan beginprijs", "optionIndex": 1 },
          { "id": "get.percent-second-on-original", "label": "Tweede stap op verkeerd basisbedrag toegepast", "optionIndex": 2 },
          { "id": "get.percent-step-omitted", "label": "Eerste stap (stijging) overgeslagen", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "GET-PROC-SAMENGESTELD-005",
      "familyId": "GET-PROC-SAMENGESTELD",
      "module": "Getalbegrip",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "procenten",
      "subSkill": "proc_samengesteld",
      "questionType": "step_solver",
      "question": "Een telefoon kost €400. Eerst 25% korting, daarna nog 20% korting op de nieuwe prijs. Bereken de eindprijs stap voor stap.",
      "context": null,
      "options": [],
      "correctAnswer": "240",
      "data": {
        "stepSolver": {
          "steps": [
            {
              "prompt": "Stap 1: Bereken de eerste korting (25% van €400)",
              "acceptedAnswers": ["100", "€100", "100 euro"],
              "hint": "25% = ¼. Een kwart van €400 = €400 ÷ 4."
            },
            {
              "prompt": "Stap 2: Wat is de tussenprijs na de eerste korting? (€400 − stap 1)",
              "acceptedAnswers": ["300", "€300", "300 euro"],
              "hint": "Trek de korting af: €400 − €100."
            },
            {
              "prompt": "Stap 3: Bereken de tweede korting (20% van de tussenprijs, niet van €400!)",
              "acceptedAnswers": ["60", "€60", "60 euro"],
              "hint": "20% van €300 = ⅕ × €300 = €300 ÷ 5."
            },
            {
              "prompt": "Stap 4: Wat is de eindprijs? (tussenprijs − stap 3)",
              "acceptedAnswers": ["240", "€240", "240 euro"],
              "hint": "Trek de tweede korting af van de tussenprijs: €300 − €60."
            }
          ]
        }
      },
      "conceptId": "percent_compound_step_by_step",
      "variantIndex": 5,
      "citoDifficulty": 0.58,
      "citoDiscrimination": 0.80,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Samengestelde korting: stap voor stap",
            "content": "Bij twee opeenvolgende kortingen MOET je stap voor stap rekenen. 25% + 20% is NIET gelijk aan 45% korting! De tweede korting gaat over de al verlaagde prijs.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Eindprijs = €240. Stap 1: 25% van €400 = €100. Stap 2: €400 − €100 = €300. Stap 3: 20% van €300 = €60. Stap 4: €300 − €60 = €240. Let op: je past de tweede korting toe op €300, niet op €400. Daarom is de totale korting (€160) niet hetzelfde als 45% van €400 (= €180).",
        "solutionSteps": [
          "Stap 1: 25% van €400 = €100",
          "Stap 2: €400 − €100 = €300",
          "Stap 3: 20% van €300 = €60",
          "Stap 4: €300 − €60 = €240"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.percent-compound-added", "label": "Percentages opgeteld (25% + 20% = 45%) i.p.v. stap voor stap" },
          { "id": "get.percent-second-on-original", "label": "Tweede korting toegepast op €400 i.p.v. €300" },
          { "id": "get.percent-step-omitted", "label": "Tweede korting overgeslagen, stopt bij €300" }
        ]
      }
    }
  ]
}
